import React, { useContext } from 'react';
import cn from 'classnames';
import { string, node } from 'prop-types';
import ModalContext from '../../context/ModalContext';
import Heading from '../../atoms/Heading';
import Icon from '../../atoms/Icon';
/**
 * Modal Header component.
 */

var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "cross",
  size: 20
});

var Header = function Header(_ref) {
  var className = _ref.className,
      children = _ref.children;

  var _useContext = useContext(ModalContext),
      onClose = _useContext.onClose;

  return /*#__PURE__*/React.createElement("div", {
    className: cn('modal__header', className)
  }, /*#__PURE__*/React.createElement(Heading, {
    className: "modal__title",
    size: 5
  }, children), /*#__PURE__*/React.createElement("button", {
    "aria-label": "Close modal",
    type: "button",
    className: "modal__close-button",
    onClick: function onClick() {
      return onClose();
    }
  }, _ref2));
};

Header.displayName = 'Modal.Header';
Header.defaultProps = {
  children: null,
  className: null
};
Header.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The content of the header */
  children: node,

  /** Additional class names to add to the component root. */
  className: string
} : {};
export default Header;